module.exports = __webpack_public_path__ + "static/media/pudjo.842bc81e.jpeg";